export const TZ = "America/Toronto";

export const TIMEFRAME_OPTIONS = [
  "Immediate (0 - 3 months)",
  "3 - 6 months",
  "6 - 9 months",
  "9 - 12 months",
  "12 - 15 months",
];

export const INTENT_OPTIONS = ["Looking to Buy", "Looking to Lease", "Not sure yet"];

function tzOffsetMs(utcMs) {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone: TZ,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const p = {};
  dtf.formatToParts(new Date(utcMs)).forEach(({ type, value }) => (p[type] = value));
  return Date.parse(`${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}:${p.second}Z`) - utcMs;
}

export function zonedToUtc(dateKey, timeStr) {
  const naive = Date.parse(`${dateKey}T${timeStr}:00Z`);
  const ts = naive - tzOffsetMs(naive);
  return new Date(naive - tzOffsetMs(ts));
}

export const DEFAULT_AVAILABILITY = { weekdays: [0, 1, 2, 3, 4], startHour: 9, endHour: 21 };

export const isoDow = (dow) => (dow + 6) % 7;

export function fmtHour(h) {
  const hr = h % 12 === 0 ? 12 : h % 12;
  return `${hr}:00 ${h < 12 ? "AM" : "PM"}`;
}

export function slotsForDate(dateKey, availability = DEFAULT_AVAILABILITY, now = new Date()) {
  const out = [];
  for (let h = availability.startHour; h <= availability.endHour - 1; h++) {
    for (const m of ["00", "30"]) {
      const time = `${String(h).padStart(2, "0")}:${m}`;
      const utc = zonedToUtc(dateKey, time);
      if (utc.getTime() - now.getTime() > 12 * 3600 * 1000) out.push({ time, utc });
    }
  }
  return out;
}

export function monthMatrix(year, month) {
  const first = new Date(Date.UTC(year, month, 1));
  const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const cells = [];
  for (let i = 0; i < first.getUTCDay(); i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) {
    const key = new Date(Date.UTC(year, month, d)).toISOString().slice(0, 10);
    cells.push({ key, day: d, dow: new Date(`${key}T12:00:00Z`).getUTCDay() });
  }
  return cells;
}

export function torontoTodayKey() {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

export function monthLabel(year, month) {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "UTC", month: "long", year: "numeric" }).format(
    new Date(Date.UTC(year, month, 1))
  );
}

export function fmtDateLong(utcDate) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ,
    weekday: "long",
    month: "long",
    day: "numeric",
  }).format(utcDate);
}

export function fmtTime(utcDate) {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ,
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(utcDate);
}